module.exports = __webpack_public_path__ + "1791188489487/images/ondato-logo.189e1d5.svg";